module.exports = __webpack_public_path__ + "img/illustration-step-3-03.08415488.svg";